module.exports = __webpack_public_path__ + "img/postprocessing.4f900f5c.png";